import { render, staticRenderFns } from "./MapEditor.vue?vue&type=template&id=e2a5972c&scoped=true&"
import script from "./MapEditor.vue?vue&type=script&lang=js&"
export * from "./MapEditor.vue?vue&type=script&lang=js&"
import style0 from "./MapEditor.vue?vue&type=style&index=0&id=e2a5972c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a5972c",
  null
  
)

component.options.__file = "MapEditor.vue"
export default component.exports